import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CashTrackingAddCashPage } from 'src/app/modals/cash-tracking-add-cash/cash-tracking-add-cash.page';

const routes: Routes = [
  {
    path: '',
    component: CashTrackingAddCashPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CashTrackingAddCashPage]
})
export class CashTrackingAddCashPageModule {}
